import { Box, Button, Tooltip, Typography } from '@material-ui/core';

import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useGetApplicationSteps } from '@/components/modules/Application/hooks/useGetApplicationSteps';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { ChannelMap } from '@/components/shared/components/AgentSelectionComponent/maps/channel.map';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { ICON_NAMES } from '@/config/config';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useUser } from '@/hooks/useUser';

export const SelectedAgentChip = () => {
  const {
    state: { selectedAgent, selectedChannel, selectedMerchant, selectedAgentHasError },
  } = useApplicationContext();

  const { palette, customBorderRadius } = useCustomTheme();
  const { isUserAdmin, isUserMerchantGroup } = useUser();
  const { initApplication, step, resetNavigation } = useApplicationNavigation();
  const { getSteps } = useGetApplicationSteps();
  const { opened, setOpened, toggleDialog } = useDialog();

  const handleClick = () => {
    initApplication();
    resetNavigation(getSteps());
    setOpened(false);
  };

  if (!selectedChannel || !selectedAgent || selectedAgentHasError !== false) {
    return null;
  }

  const channelItem = ChannelMap.toSelectItem(selectedChannel);

  return (
    <>
      <Tooltip
        title={`${selectedMerchant?.businessName ?? 'Selected merchant'} > ${
          channelItem.name ?? 'Selected channel'
        } > ${selectedAgent.name}`}
      >
        <CustomPaper fill="paper" style={{ padding: 8 }}>
          <FlexRow>
            <Button
              disabled={!step}
              onClick={() => setOpened(true)}
              variant="text"
              fullWidth
              style={{
                borderRadius: customBorderRadius.paper,
                justifyContent: 'flex-start',
                paddingLeft: '16px',
                paddingRight: '16px',
              }}
            >
              {(isUserAdmin || isUserMerchantGroup) && (
                <>
                  <Box display={'flex'} flexDirection={'row'} overflow={'hidden'} alignItems={'center'}>
                    <Icon size={18} color={palette.secondary.main} style={{ marginRight: 8 }}>
                      {ICON_NAMES.MERCHANT}
                    </Icon>
                    <Typography variant={'body2'} color={'textSecondary'} className="overflow-text-ellipsis">
                      {selectedMerchant?.businessName ?? 'Selected merchant'}
                    </Typography>
                  </Box>
                  <Icon size={20} color={palette.grey[400]} style={{ paddingInline: '4px' }}>
                    {'chevron_right'}
                  </Icon>
                </>
              )}
              <Box display={'flex'} flexDirection={'row'} overflow={'hidden'} alignItems={'center'}>
                <Icon size={18} color={palette.secondary.main} style={{ marginRight: 8 }}>
                  {channelItem.icon ?? 'storefront'}
                </Icon>
                <Typography variant={'body2'} color={'textSecondary'} className="overflow-text-ellipsis">
                  {channelItem.name ?? 'Selected channel'}
                </Typography>
              </Box>
              <Icon size={20} color={palette.grey[400]} style={{ paddingInline: '4px' }}>
                {'chevron_right'}
              </Icon>
              <Box display={'flex'} flexDirection={'row'} overflow={'hidden'} alignItems={'center'}>
                <Icon size={18} color={palette.secondary.main} style={{ marginRight: 8 }}>
                  {'person'}
                </Icon>
                <Typography variant={'body2'} color={'textSecondary'} className="overflow-text-ellipsis">
                  {selectedAgent.name}
                </Typography>
              </Box>
            </Button>
          </FlexRow>
        </CustomPaper>
      </Tooltip>
      <ActionDialog
        opened={opened}
        setOpened={setOpened}
        handleClose={toggleDialog}
        Title={<Text tId={'SELECT_NEW_AGENT'} />}
        onSubmit={handleClick}
        Description={<Text tId={'SELECT_NEW_AGENT_NOTICE'} />}
        MainButton={<Text tId={'SELECT'} />}
      />
    </>
  );
};
